import { COLOR } from '../../SignupLogin/constants/style';

const Input = {
  sizes: {
    md: {
      field: {
        fontSize: '14px',
      },
    },
  },
  baseStyle: {
    field: {
      padding: '12px',
      minHeight: '44px',
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: '400',
      color: '#333333',
      boxSizing: 'border-box',
      border: '1px solid #DDDDDD',
      _placeholder: {
        color: '#999999',
      },
    },
    _focus: {
      boxShadow: 'none',
      _invalid: {
        borderColor: COLOR.ERROR,
      },
    },
  },
  defaultProps: {
    errorBorderColor: COLOR.ERROR,
    // https://github.com/chakra-ui/chakra-ui/issues/2347#issuecomment-917375118
    variant: null,
  },
};

export default Input;
